import Cookies from 'js-cookie'

const TokenKey = 'nisbos_auth_token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function getSystemId() {
  return Cookies.get('systemId')
}

export function setToken(token, key = TokenKey) {
  return Cookies.set(key, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
